<div class="order">
  <div class="order-text">
    <rc-rounded-step [step]="'1'"></rc-rounded-step>
    <p>
      Pentru a plasa o comandă personalizată vă rugăm să ne contactați la numărul
      <a (click)="trackConversion('Pv7pCN3In6QZELWMoq4q')" href="tel:0740101510">0740 101 510</a> sau pe email
      <a href="mailto:vanzari@experttabla.ro">vanzari@experttabla.ro</a>
    </p>
    <rc-rounded-step [step]="'2'"></rc-rounded-step>
    <p>Vom reveni către dvs. cu cea mai bună ofertă.</p>
    <rc-rounded-step [step]="'3'"></rc-rounded-step>
    <p>După confirmarea plății, produsele vor fi livrate către dvs.</p>
  </div>
</div>
